import { readJson, writeJson } from "./local-store.ts"

/**
 * 표에 어떤 칸을 보여 줄지 사람마다 고른다.
 *
 * 화면 폭에 따라 접는 것(`ui/table-columns.ts` 의 priority)과는 다른 일이다 —
 * 그쪽은 "지금 자리가 없다", 이쪽은 "나는 이 칸을 안 본다". 둘 다 통과한 칸만 보인다.
 *
 * 저장된 값에 모르는 열쇠가 섞여 있어도(칸 이름이 바뀌었거나 지워졌어도) 걸러 낸다.
 */
export type ColumnChoice = { key: string; label: string }

export function resolveVisible(
  all: readonly ColumnChoice[],
  stored: readonly string[] | null,
  fallback: readonly string[],
): string[] {
  const known = new Set(all.map((column) => column.key))
  if (stored) {
    const kept = stored.filter((key) => known.has(key))
    // 전부 지워 빈 표가 되는 것은 막는다 — 그 상태에서는 되돌릴 단추조차 안 보인다.
    if (kept.length > 0) return kept
  }
  return fallback.filter((key) => known.has(key))
}

export function toggleColumn(visible: readonly string[], key: string): string[] {
  if (visible.includes(key)) {
    const next = visible.filter((other) => other !== key)
    // 마지막 한 칸은 끄지 못한다.
    return next.length === 0 ? [...visible] : next
  }
  return [...visible, key]
}

export function loadColumns(key: string): string[] | null {
  const raw = readJson<unknown>(key, null)
  if (!Array.isArray(raw)) return null
  return raw.filter((item): item is string => typeof item === "string")
}

export function saveColumns(key: string, visible: readonly string[]): void {
  writeJson(key, visible)
}
